import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import Particle from "../Particle";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null); // To store error messages

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null); // Reset the error state

    try {
      const response = await fetch("/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", message: "" });
        setTimeout(() => setSubmitted(false), 3000);
      } else {
        setError("Failed to submit form. Please try again later.");
      }
    } catch (error) {
      setError("Error occurred while submitting the form.");
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container fluid className="about-section" style={{ position: "relative" }}>
      <Particle />
      <Container>
        {/* Floating Call-to-Action Section */}
        <div
          style={{
            position: "absolute",
            top: "120px", // Positioned lower to avoid overlap
            right: "20px",
            background: "rgba(25, 25, 25, 0.95)",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.6)",
            maxWidth: "300px",
            zIndex: 1000, // High z-index ensures it stays on top
          }}
        >
          <h4
            style={{
              color: "white",
              fontWeight: "bold",
              fontSize: "1.2rem",
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            You got Questions? I got Answers.
          </h4>
          <Button
            variant="danger"
            href="https://cal.com/chayan-mondal-k6icny" // Replace with your Calendly link
            className="rounded-pill w-100"
            style={{
              fontWeight: "bold",
              fontSize: "0.9rem",
              backgroundColor: "#FF5733",
              borderColor: "#FF5733",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Book a call{" "}
            <span
              style={{
                marginLeft: "5px",
                fontWeight: "bold",
                fontSize: "1rem",
                display: "inline-block",
                lineHeight: "1",
              }}
            >
              →
            </span>
          </Button>
        </div>

        {/* Contact Form Section */}
        <Row className="justify-content-center" style={{ zIndex: 900 }}>
          <Col
            md={7}
            className="p-4 shadow-lg rounded"
            style={{
              background: "rgba(25, 25, 25, 0.9)",
              borderRadius: "15px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
              color: "white",
              position: "relative",
              zIndex: 900, // Ensures form is above other elements
            }}
          >
            <h2
              className="text-center mb-4"
              style={{ color: "#FFFFFF", fontSize: "2rem" }}
            >
              Contact Me
            </h2>
            {submitted && (
              <Alert variant="success" className="text-center">
                Your message has been successfully sent!
              </Alert>
            )}
            {error && (
              <Alert variant="danger" className="text-center">
                {error}
              </Alert>
            )}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
                  Name
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="rounded-pill"
                  style={{
                    backgroundColor: "#2c2c2c",
                    color: "white",
                    borderColor: "#444",
                    fontSize: "1.1rem",
                    padding: "12px",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
                  Email Address
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="rounded-pill"
                  style={{
                    backgroundColor: "#2c2c2c",
                    color: "white",
                    borderColor: "#444",
                    fontSize: "1.1rem",
                    padding: "12px",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Label style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
                  Message
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Write your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="rounded"
                  style={{
                    backgroundColor: "#2c2c2c",
                    color: "white",
                    borderColor: "#444",
                    fontSize: "1.1rem",
                    padding: "12px",
                  }}
                />
              </Form.Group>
              <div className="text-center">
                <Button
                  variant="primary"
                  type="submit"
                  className="rounded-pill px-4"
                  disabled={isSubmitting}
                  style={{
                    backgroundColor: "#6C63FF",
                    borderColor: "#6C63FF",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    padding: "12px 20px",
                  }}
                >
                  {isSubmitting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Send Message"
                  )}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;
